import { useState } from "react";
import { activateSemester } from "../../_services/semester.service";

export const useActivateSemester = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleActivateSemester = async (id, callback) => {
    setLoading(true);
    try {
      const response = await activateSemester(id);
      setData(response);
      if (callback) callback();
    } catch (error) {
      console.error("Error activating semester:", error);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, handleActivateSemester };
};
